import { render, staticRenderFns } from "./SchemaEditor.vue?vue&type=template&id=e2ac57a2&scoped=true&"
import script from "./SchemaEditor.vue?vue&type=script&lang=js&"
export * from "./SchemaEditor.vue?vue&type=script&lang=js&"
import style0 from "./SchemaEditor.vue?vue&type=style&index=0&id=e2ac57a2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ac57a2",
  null
  
)

export default component.exports